<template>
  <div class="application-bar md-offset">
    <md-snackbar :md-active.sync="snackbar.show" :md-duration="8000">
      <span>
        <template v-if="snackbar.icon">
          <md-icon class="md-primary">{{ snackbar.icon }}</md-icon>
          &nbsp;&nbsp;&nbsp;
        </template>
        {{ snackbar.content }}
      </span>
      <md-button
        class="md-primary md-simple md-dense"
        @click="snackbar.show = false"
        >Dismiss</md-button
      >
    </md-snackbar>

    <md-dialog-alert
      :md-active.sync="error_dialog.show"
      :md-title="error_dialog.title"
      :md-content="error_dialog.content" />

    <!-- Application Status Editor -->
    <UpdateComponent :update_status="application_update_status_dialog" />

    <!-- Manage Owners Editor -->
    <ManageOwnersComponent :manage_owners="application_update_owners_dialog" />
    <CommentDialogComponent :manage_owners="application_comment_dialog" />
    <UpdateUserProfileComponent
      :user-profile-dialog="edit_user_profile_dialog"
    />
    <QuickResponseComponent :quick_response="application_quick_response_dialog" />
    <div v-if="application_referrer.show">
      <p style="margin-right:50px;">Referrer: {{application_referrer.referrer}}</p>
    </div>
    <div class="">
      <p>Open Application:</p>
      <p>
        <span v-if="application_status.dirty">*</span>
        <span v-if="application_status.loaded">{{
          application.applicants[0].contact.name | name
        }}</span>
      </p>
      <md-tooltip class="application-tooltip">
        <span v-if="application_status.id == null">New</span>
        <table v-if="application_status.loaded">
          <tbody>
            <tr>
              <td>ID:</td>
              <td>
                <span v-if="application_status.id == null">New</span>
                <span v-else>{{ application.loan.id }}</span>
              </td>
            </tr>
            <tr>
              <td>Stage:</td>
              <td>{{ application.loan.status.stage }}</td>
            </tr>
            <tr>
              <td>Status:</td>
              <td>{{ application.loan.status.status }}</td>
            </tr>
            <tr>
              <td>NAF:</td>
              <td>{{ asset_requested_amount | currency }}</td>
            </tr>
            <tr v-if="application.loan.asset.type == 'Vehicle'">
              <td>Vehicle:</td>
              <td>
                {{ application.loan.asset.vehicle.model_year }}
                {{ application.loan.asset.vehicle.make }}
                {{ application.loan.asset.vehicle.model }}
              </td>
            </tr>
            <tr>
              <td>Phone:</td>
              <td v-if="application.applicants[0].contact.phones[0].phone_number != ''">
                {{ application.applicants[0].contact.phones[0].phone_number }}
              </td>
              <td v-else-if="application.applicants[0].contact.phones[1].phone_number != ''">
                {{ application.applicants[0].contact.phones[1].phone_number }}
              </td>
              <td v-else>
                {{ application.applicants[0].contact.phones[2].phone_number }}
              </td>
            </tr>
            <tr>
              <td>Veda 2.0:</td>
              <td v-if="application.applicants[0].veda_report">
                <span v-if="application.applicants[0].veda_report.success">
                    {{ application.applicants[0].veda_report.credit_score.v_20 }}
                </span>
              </td>
            </tr>
            <tr v-if="application.loan.asset.type == 'Personal'">
              <td>Personal Loan</td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </md-tooltip>
    </div>

    <md-menu md-size="medium" md-direction="bottom-start" md-align-trigger class="">
      <md-button
        md-menu-trigger
        class="md-primary md-simple"
        :disabled="application_status.id === null">
        <md-icon>bolt</md-icon>
        Actions
        <md-icon>arrow_drop_down</md-icon>
      </md-button>

        <md-menu-content class="action-menu">
        <md-menu-item @click="onLoadedApplicationOpenUpdateStatus">
          <md-tooltip md-direction="left">Update the status of the application</md-tooltip>
          <md-icon>update</md-icon>
          Update Status
        </md-menu-item>
        <md-menu-item @click="onLoadedApplicationOpenManageOwners">
          <md-tooltip md-direction="left">Manage the loan application owners</md-tooltip>
          <md-icon>manage_accounts</md-icon>
          Manage Owners
        </md-menu-item>
        <md-menu-item @click="onLoadedApplicationOpenGenerateApplicationDocument">
          <md-tooltip md-direction="left">Generate loan application document</md-tooltip>
          <md-icon>attach_file</md-icon>
          Generate Application Document
        </md-menu-item>
        <md-menu-item @click="onLoadApplicationOpenQuickResponse">
          <md-tooltip md-direction="left">Send Quick Response</md-tooltip>
          <md-icon>send</md-icon>
          Quick Response
        </md-menu-item>
      </md-menu-content>
    </md-menu>

    <md-menu md-size="medium" md-direction="bottom-start" md-align-trigger :md-active.sync="showProfileMenu">
      <md-button
        md-menu-trigger
        class="md-primary md-simple"
        :disabled="!application_status.loaded">
        <md-icon>account_circle</md-icon>
         {{ user | shortName }}
        <md-icon>arrow_drop_down</md-icon>
      </md-button>

      <md-menu-content class="action-menu">
        <md-menu-item @click="editProfile">
          <md-icon>edit</md-icon>
          Edit Profile
        </md-menu-item>
        <md-menu-item @click="changePassword">
          <md-icon>lock</md-icon>
          Change Password
        </md-menu-item>
        <md-menu-item @click="logout">
          <md-icon>logout</md-icon>
          Logout
        </md-menu-item>
        <md-menu-item v-if="userHasRole('Dealer Agent')">
          <div class="md-layout-item md-size-10">
            <loading-icon-text-button
              md-menu-trigger
              class="md-primary"
              @click="getIntroducers"
              icon="restart_alt"
              :loading="application_status.loading"
            >
              Generate Link
            </loading-icon-text-button>
          </div>
        </md-menu-item>
      </md-menu-content>
    </md-menu>

    <!-- Change Password Dialog Start -->
    <md-dialog :md-active.sync="show.change_password_dialog">
      <md-dialog-title>Change Password</md-dialog-title>
      <div v-if="errorMessage != '' && errorMessage != null">
        <p class="errorMsg">{{ errorMessage }}</p>
      </div>
      <div class="md-layout">
        <!-- Old Password -->
        <validated-password-input class="md-layout-item md-small-size-100 md-size-30"
                              label="Old Password"  v-model="passwordData.old_password" required>
        </validated-password-input>

        <!-- New Password -->
        <validated-password-input class="md-layout-item md-small-size-100 md-size-30"
                              label="New Password" :minLength="8" v-model="passwordData.new_password" required>
        </validated-password-input>

        <!-- Confirm Password -->
        <validated-password-input class="md-layout-item md-small-size-100 md-size-30"
                              label="Confirm Password" v-model="passwordData.confirm_password" required>
        </validated-password-input>
      </div>
      <md-dialog-actions>
        <md-button class="md-primary md-simple" @click="onChangePasswordCancel">Cancel</md-button>
        <md-button class="md-primary md-simple" @click="onChangePasswordSave"
          :disabled="!passwordData.old_password || !passwordData.new_password || !passwordData.confirm_password ">Save
        </md-button>
      </md-dialog-actions>
    </md-dialog>
    <!-- Change Password Dialog End -->

    <!-- Referrer Dialog Start -->
    <md-dialog :md-active.sync="show.select_referrer_dialog">
      <div v-if="!agentLink" class="md-layout md-gutter custom-dropdown">
        <md-dialog-title>Select Referrer</md-dialog-title>
          <div class="md-layout-item">
            <md-field>
              <md-select
                v-model="selectedReferrerId"
              >
                <md-option v-for="item in introducersData" :key="item && item.id" :value="item.id">
                  {{ item ? item.full_name : '' }}
                </md-option>
              </md-select>
            </md-field>
          </div>
      </div>
      <div
        v-else
        class="card-button"
      >
        <md-card-header>
          <div class="md-title">Agent Link</div>
        </md-card-header>

        <div @click="copyAgentLink">
        <md-card-content class="copy-button">
          <md-icon class="copy-icon md-size-2x">content_copy</md-icon>
          <p>{{ this.agentLink }}</p>
        </md-card-content>
        </div>
      </div>
    </md-dialog>
    <!-- Referrer Dialog End -->

    <loading-icon-text-button
      :class="{ 'md-simple': !application_status.dirty }"
      @click="saveApplication"
      icon="save"
      :loading="application_status.loading"
      :disabled="!save_button_enabled || application_status.loading || (current_lock.app_id != null)"
    >
      Save
    </loading-icon-text-button>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { PropertyView } from "@/components";
import LoadingIconTextButton from "@/components/LoadingIconTextButton";
import filters from "@/components/utils/filters";

import UpdateComponent from "@/components/TransferAndUpdate/UpdateComponent";
import ManageOwnersComponent from "@/components/TransferAndUpdate/ManageOwnersComponent";
import CommentDialogComponent from "@/components/TransferAndUpdate/CommentDialogComponent";
import ValidatedInputs from '@/components/ValidatedInput';
import ValidatedPasswordInput from "./ValidatedInput/ValidatedPasswordInput";
import UpdateUserProfileComponent from "./TransferAndUpdate/UpdateUserProfileComponent.vue";
import QuickResponseComponent from "./Document/QuickResponseComponent.vue";
import ConfirmDialog from "@/components/Dialogs/ConfirmDialog";

export default {
  components: {
    LoadingIconTextButton,
    PropertyView,
    UpdateComponent,
    ManageOwnersComponent,
    CommentDialogComponent,
    ValidatedPasswordInput,
    UpdateUserProfileComponent,
    ...ValidatedInputs,
    QuickResponseComponent,
    ConfirmDialog,
  },
  data() {
    return {
      isMelissaCheckPassed: false,
      errorMessage : null,
      agentLink: "",
      selectedReferrerId: null,
      introducersData: {},
      showProfileMenu: false,
      passwordData:{
        old_password : null,
        new_password : null,
        confirm_password : null,
      },
      snackbar: {
        show: false,
        icon: "done",
        content: "",
      },
      error_dialog: {
        show: false,
        title: '',
        content: '',
      },
      update_status: {
        show: false,
        application: null,
        stage: null,
        status: null,
        archived: null,
      },
      manage_owners: {
        query: "",
        searching: false,
        users: [],
        show: false,
        application: null,
        selected_user: null,
      },
      show: {
        change_password_dialog: false,
        select_referrer_dialog: false
      },
    };
  },
  watch: {
    selectedReferrerId(newVal) {
      this.generateAgentLink(newVal);
    }
  },
  computed: {
    ...mapGetters([
      "application",
      "application_status",
      "user",
      "application_update_status_dialog",
      "application_update_owners_dialog",
      "application_comment_dialog",
      "application_quick_response_dialog",
      "application_referrer",
      "security",
      "error_fields",
      "userHasPermission",
      "current_lock",
      "userHasRole",
      "user",
      "edit_user_profile_dialog",
    ]),
    save_button_enabled() {
      if (!this.application_status.loaded) {
        return false;
      }

      let savable_pages = ["Capture", "Submission", "Assess & Submit"];

      if (savable_pages.includes(this.$route.name)) {
        if (this.application) {
          return this.application.permissions.update;
        } else {
          return this.user.permissions.includes("create loan-application");
        }
      } else {
        return false;
      }
    },
    asset_requested_amount(){
        return this.security.requested_amount;
    }
  },
  methods: {
    async saveApplication() {
      if (!this.application_status.disable_save) {
        try {
          let result = await this.$store.dispatch("save_application", this.application);

          if (result) {
            this.snackbar.content = "Application saved successfully";
            this.snackbar.icon = "done";
            this.snackbar.show = true;
            this.$store.commit("redirect_after_save", this.application);
          }
        } catch (e) {
          if (e.response
          && e.response.data
          && e.response.data.error
          && e.response.status) {
            if (e.response.status === 403 && e.response.data.error === 'Confirm overwrite to not given') {
              const res = await this.showNotification(
                "Confirm",
                `<span class="text-danger" style="font-weight: bold;">
                  Please confirm that the privacy consent will be overwritten from the current privacy consent to Not Given?
                </span>`,
                "Confirm"
              );
              if (res) {
                if (this.application?.applicants?.[0]?.privacy_consent) {
                  this.application.applicants[0].privacy_consent.force_save_consent = true;
                }
                this.saveApplication();
                if (this.application?.applicants?.[0]?.privacy_consent) {
                  this.application.applicants[0].privacy_consent.force_save_consent = false;
                }
                return;
              } else {
                this.error_dialog.title = "Privacy consent";
                this.error_dialog.content = `<span class="text-danger" style="font-weight: bold;">
                  Application has not been saved.
                </span>`;
                this.error_dialog.show = true;
                return;
              }
            }
          }
          this.error_dialog.title = "Error saving application";
          this.error_dialog.content = `Error Message: ${e.response.data.error}`;
          this.error_dialog.show = true;
        }
      } else {
        this.error_dialog.title = 'Failed to save Application';
        this.error_dialog.content = filters.getErrorFieldsMessage(this.error_fields);
        this.error_dialog.show = true;
      }
    },
    showNotification(title, content, confirmText = 'Proceed', cancelText = 'Cancel') {
      return this.$modal.show(ConfirmDialog, {
        title: title,
        message: content,
        confirmText: confirmText,
        cancelText: cancelText,
      });
    },
    getApplicationMetadata() {
      return {
        id: this.application.loan.id,
        status: {
          stage: this.application.loan.status.stage,
          status: this.application.loan.status.status,
          reason: this.application.loan.status.reason,
          comment: this.application.loan.status.comment,
        },
      };
    },
    async getIntroducers() {
      try {
        this.agentLink = ""
        this.show.select_referrer_dialog = true;
        this.showProfileMenu = false;
        const response = await axios.get(`/api/v1/application/getReferrersByPod`);
        this.introducersData = response.data.filter(item => item !== null);
      } catch (error) {
        console.error('Error fetching introducers', error);
      }
    },
    async onLoadedApplicationOpenManageOwners() {
      if (await this.checkApplicationLock() === false) {
        return false;
      }
      if (this.application_status.dirty) {
        await this.$store.dispatch("save_application", this.application);
      }

      this.$store.commit('set_application_update_owners_dialog', this.getApplicationMetadata());
    },
    async onLoadedApplicationOpenUpdateStatus() {
      if (await this.checkApplicationLock() === false) {
        return false;
      }
      if (this.application_status.dirty && !this.application_status.disable_save) {
        try {
          let result = await this.$store.dispatch("save_application", this.application);

          if (result) {
            this.$store.commit('set_application_update_status_dialog', this.getApplicationMetadata());
          }
        } catch (e) {
          this.error_dialog.title = "Error saving application";
          this.error_dialog.content = `Error Message: ${e.response.data}`;
          this.error_dialog.show = true;
        }
      } else {
        // allow application update without save
        this.$store.commit('set_application_update_status_dialog', this.getApplicationMetadata());
      }
    },
    async onLoadedApplicationOpenGenerateApplicationDocument() {
      const payload = {
        application: this.application,
      }
      await this.$store.dispatch("submit_generate_application_document", payload);
    },
    async onLoadApplicationOpenQuickResponse() {
      if (await this.checkApplicationLock() === false) {
        return false;
      }
      if (this.application_status.dirty) {
        await this.$store.dispatch("save_application", this.application);
      }

      this.$store.commit('set_application_quick_response_dialog', this.getApplicationMetadata());
    },
    updateMelissaCheck(isMelissaCheckVal) {
        this.isMelissaCheckPassed = isMelissaCheckVal;
    },
    async editProfile() {
      const payload = {
        'show': true,
        'title': 'Edit user profile.',
      };
      await this.$store.commit('set_edit_user_profile_dialog', payload);
    },
    generateAgentLink(selectedRefId) {
      const origin = window.location.origin;
      let base;

      if (origin.includes('stage.zink')) {
        base = 'https://consumer.stage.zink.com.au';
      } else if (origin.includes('localhost')) {
        base = 'http://localhost:3000';
      } else {
        base = 'https://consumer.zink.com.au';
      }

      const introducer = this.introducersData.find(item => item && item.id === selectedRefId);
      const logoUrl = introducer ? introducer.logo_url || '' : '';

      // Include ref_logo parameter if logoUrl is not null or empty
      const refLogoParam = logoUrl ? `&ref_logo=${logoUrl}` : '';

      this.agentLink = `${base}/v1?agent_id=${this.user.id}&loan_asset=Car&ref=${selectedRefId}${refLogoParam}`;
    },
    async copyAgentLink() {
      try {
        await navigator.clipboard.writeText(this.agentLink);
        this.snackbar.content = "Agent Link copied to clipboard";
        this.snackbar.icon = "done";
        this.snackbar.show = true;
        this.selectedReferrerId = null;
        this.show.select_referrer_dialog = false;
      } catch (err) {
        this.show.select_referrer_dialog = false;
        console.error('Unable to copy to clipboard', err);
      }
    },
    async changePassword() {
      this.errorMessage = '';
      this.show.change_password_dialog = true;
      this.passwordData.old_password = null;
      this.passwordData.new_password = null;
      this.passwordData.confirm_password = null;
    },
    onChangePasswordCancel() {
      this.show.change_password_dialog = false;
    },
    async onChangePasswordSave() {
      if (this.passwordData.new_password.length < 8) {
        this.errorMessage = "Password length must be greater than 8 characters.";
      } else if (this.passwordData.new_password != this.passwordData.confirm_password) {
        this.errorMessage = "Your new password and confirm password not match";
      } else {
        await axios.post(
          "/api/v1/user/change_password", this.passwordData
        ).then(async (res) => {
          this.show.change_password_dialog = false;
          this.snackbar.content = "Change password successfully";
          this.snackbar.icon = "done";
          this.snackbar.show = true;
        }).catch((err) => {
          console.log(err);
          this.errorMessage = err.response.data;
        });
      }
   },
   logout() {
      const self = this;
      axios.get('/logout')
          .then(function (response) {
            self.$router.push("/login")
        }).catch(function (error) {
            console.log(error);
        });
   },
    async checkApplicationLock() {
      if (this.$route.name !== 'Capture'
        && this.userHasPermission('bypass-application-lock') === false
        && await this.$store.dispatch('check_application_lock', this.application.loan.id) == false) {
          this.$notifications.notify({
            'message': this.current_lock.messages,
            'icon': 'lock',
            'timeout': 5000,
            'verticalAlign': 'top',
            'horizontalAlign': 'center'
          })
          return false
      }
    },
  },
  filters: {
    ...filters,
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/scss/theme.scss";

.application-bar {
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

@media screen and (max-width:1760px) {
  .application-bar {
    max-width: 50%;
    min-width: 50%;
    justify-content: start;
    padding-left: 0px;
  }
}


::v-deep .md-button .md-ripple {
  padding-right: 15px !important;
  padding-right: 15px !important;
}

.application-tooltip {
  text-align: start;
  max-width: 400px;

  & table td {
    padding-right: 5px;
  }
}

.topbar-search {
  .md-select {
    width: 20px;
  }
}

.errorMsg {
  padding: 5px 20px;
}

.custom-dropdown {
  display: flex;
  flex-direction: column;
  padding: 20px;
  margin-bottom: 40px;
}

.copy-button {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  cursor: pointer;
  margin: 20px;
  font-size: 18px;
  align-items: center;
}

.card-button {
  padding: 20px;
}

.copy-icon {
  padding-right: 10px;
}

</style>
